import React from "react";
import ListadoDiaDeporte from "./listadoDiaDeporte/listadoDiaDeporte";
import "./envivoDeporte.sass";

export default function EnvivoDeporte({seccion, deporte}) {

    return (
        <>
            <ListadoDiaDeporte seccion={seccion} deporte={deporte} />
        </>
    )
}